<template>
  <div class="admin-login-wrap">
    <div class="admin-login-box">
      <h3>测试</h3>
      <div class="form-item">
        <label>随机数I</label>
        <el-input v-model="form.userId" placeholder="请输入随机数I"></el-input>
      </div>
      <div class="form-item">
        <label>随机数U</label>
        <el-input v-model="form.uuid" placeholder="请输入随机数U"></el-input>
      </div>
      <div class="form-item">
        <label>类型</label>
        <el-radio-group v-model="form.roleId">
          <el-radio :label="1">tttt</el-radio>
          <el-radio :label="2">zzzz</el-radio>
        </el-radio-group>
      </div>
      <el-button type="primary" :loading="loading" @click="handleLogin" style="width:100%;margin-top:20px;">
       提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { loginByUuid } from '@/api/user/api'
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      loading: false,
      form: {
        userId: '',
        uuid: '',
        roleId: 1
      }
    }
  },
  methods: {
    async handleLogin() {
      if (!this.form.userId) {
        this.$message.error('请输入I')
        return
      }
      if (!this.form.uuid) {
        this.$message.error('请输入U')
        return
      }
      this.loading = true
      try {
        const res = await loginByUuid({
          userId: this.form.userId,
          uuid: this.form.uuid,
          roleId: this.form.roleId
        })
        if (res.code == 200) {
          this.$message.success('提交成功')
          Cookies.set('token', res.data)
          const type = this.form.roleId === 2 ? 'agent' : 'bidder'
          Cookies.set(`token_${type}`, res.data)
          setTimeout(() => {
            if (this.form.roleId === 2) {
              this.$router.push('/agentHome')
            } else {
              this.$router.push('/bidderHome')
            }
          }, 300)
        } else {
          this.$message.error(res.msg || '提交失败')
        }
      } catch (e) {
        this.$message.error('提交失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.admin-login-wrap {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
}
.admin-login-box {
  width: 400px;
  padding: 40px 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}
.admin-login-box h3 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}
.form-item {
  margin-bottom: 18px;
}
.form-item label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #606266;
}
</style>
